import React from 'react';
import { Navigate } from 'react-router-dom';
import { useKeycloakAuth } from '@/hooks/useKeycloakAuth';
import { MaintenanceMode } from '@/components/MaintenanceMode';
import { RedirectToKeycloakLogin } from '@/components/RedirectToKeycloakLogin';
import { MAINTENANCE_MODE, MAINTENANCE_TITLE, MAINTENANCE_DESCRIPTION } from '@/config/maintenance';
import { usePermissions } from '@/hooks/useUnifiedAuth';
import { AccessDenied } from '@/components/AccessDenied';

interface BulkUpdateRouteProps {
  children: React.ReactNode;
}

// UUIDs dos usuários autorizados a acessar a página de atualização em massa
const AUTHORIZED_USER_IDS = [
  '40b6edf3-f8cb-4730-9363-7e3ee4956adc', // Isabelle Soares
  'bc240f47-bf4f-44b6-9e8e-019a686acb4d', // Marcos Ribas
  'bf2cc762-1c6d-4618-841f-fc2d5f2e4147', // Daniel Rodrigues
];

export const BulkUpdateRoute = ({ children }: BulkUpdateRouteProps) => {
  const { isAuthenticated, isLoading } = useKeycloakAuth();
  const { isInternal } = usePermissions();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Verificar se o usuário está autenticado
  if (!isAuthenticated) {
    return <RedirectToKeycloakLogin />;
  }

  // Verificar modo de manutenção
  if (MAINTENANCE_MODE) {
    return <MaintenanceMode title={MAINTENANCE_TITLE} description={MAINTENANCE_DESCRIPTION} />;
  }


  // Ferramenta interna (GR-637). Antes daqui o guard só validava autenticação —
  // o card em Configuracoes.tsx é filtrado por `is_internal`, mas a URL
  // entregava a tela a qualquer usuário logado.
  if (!isInternal) {
    return <AccessDenied area="à atualização em massa" />;
  }

  return <>{children}</>;
};
